<template>
  <!--Start Page Banner-->
  <div class="page-banner-area bg-1">
    <div class="container">
      <div class="page-banner-content">
        <h1>Contact Us</h1>
        <ul>
          <li><a href="/">Home</a></li>
          <li>Contact Us</li>
        </ul>
      </div>
    </div>
  </div>
  <!--End Page Banner-->

  <div class="contact-us-area pt-100 pb-70">
    <div class="container">
      <div class="row">
      <!-- add map -->
      <div class="col-lg-6">

      <iframe style="height:100%;width:100%;border:0;" frameborder="0" src="https://www.google.com/maps/embed/v1/place?q=Vedanta+Post+Graduate+Girls+College&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
      </div>
        <div class="col-lg-6">
          <div class="contact-and-address">
            <h2>Get in Touch: Connecting Dreams to Reality</h2>
            <div class="contact-and-address-content">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="contact-card">
                    <div class="icon">
                      <i class="ri-phone-line"></i>
                    </div>
                    <h4>Contact</h4>
                    <p><a href="tel:+919785371692 ">97853 71692 </a></p>
                    <p style="font-size:13px;">
                      <a href="mailto:principal.vpggc@vedantafoundation.org">principal.vpggc@vedantafoundation.org</a
                      >
                    </p>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div class="contact-card">
                    <div class="icon">
                      <i class="ri-map-pin-line"></i>
                    </div>
                    <h4>Address</h4>
                    <p>
                      Opp. Nagar Palika, Khatushyamji Road, Ringus, Rajasthan-
                      332404
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="social-media">
              <h3>Social Media</h3>
              <ul>
                <li>
                  <a href="https://www.facebook.com/womencollegereengus?mibextid=ZbWKwL" target="_blank"
                    ><i class="ri-facebook-fill"></i
                  ></a>
                </li>
                <li>
                  <a href="https://www.instagram.com/vedantacollegereengus?igsh=ZjRrbmF2ajNlZWFu" target="_blank"
                    ><i class="ri-instagram-fill"></i
                  ></a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/vedanta-p-g-girls-college-r-33a4a6253?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank"><i class="ri-linkedin-fill"></i></a>
                </li>
                <li>
                  <a href="https://youtube.com/@vedantapggirlscollegereeng9330?si=MgxBLE2ibuybHhR4" target="_blank"><i class="ri-youtube-fill"></i></a>
                </li>
                <li>
                  <a href="https://wa.me/91978537169?text=Welcome%20to%20Vedanta%20PG%20Girls%20College,%20Reengus.%20%0AHow%20can%20I%20assist%20you%20today%20?" target="_blank"><i class="ri-whatsapp-fill"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactView",
};
</script>
